<app-page-placeholder [icon]="icon" [title]="pageTitle" [subtitle]="subtitle"></app-page-placeholder>
